var $1e6ebe8101abab2a$exports = {};
$1e6ebe8101abab2a$exports = {
    "backButton": (args)=>`Tagasi ${args.prevMenuButton}`,
    "moreActions": `Veel toiminguid`,
    "unavailable": `Pole k\xe4ttesaadav, \xfcksikasjade vaatamiseks laiendage`
};


export {$1e6ebe8101abab2a$exports as default};
//# sourceMappingURL=et-EE.mjs.map
